import { Component, OnInit, ViewChild, OnDestroy, Input, OnChanges, SimpleChanges  } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Transfer } from 'src/app/app.models';
import { TransferService } from 'src/app/services/transfer.service';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';


@Component({
  selector: 'app-transfer-table',
  templateUrl: './transfer-table.component.html',
  styleUrls: ['./transfer-table.component.scss']
})
export class TransferTableComponent implements OnInit, OnDestroy, OnChanges  {

  @Input('valueChange') valueChange: boolean;
  @Input('key') key: string;

  transferSubscription: Subscription

  transferGetted: boolean = false;

  user: any;
  transfers: Array<Transfer>;

  displayedColumns: string[] = ['amount', 'status', 'date'];

  dataSource!: MatTableDataSource<Transfer>;

  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(
    private transferService: TransferService,
    public appService: AppService,
    private verifResponsiveService:VerifResponsiveService
    ) { }

  ngOnInit(): void {

    this.initProperty();
    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      this.viewType = data ? 'grid' : 'list';
    });
  }

  initProperty() {
    
    this.user = JSON.parse(localStorage.getItem("user")!)

    let obj = {
      'idUser': this.user.id,
      'key': this.key
    }

    this.transferSubscription = this.transferService.transferOfUser(obj).subscribe((data: any) => {
      
      this.transfers = data.transfers;

      // console.log(data);

      this.dataSource = new MatTableDataSource(data.transfers);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort; 
      
    });
   
  }


  ngOnChanges(changes: SimpleChanges) {

    if(this.valueChange == true) {

      this.initProperty();

    }
    
  }

  ngOnDestroy(): void {
    
    if(this.transferGetted) {

      this.transferSubscription.unsubscribe();

    }

  }

  public refresh(){
    this.initProperty();
  }
 
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }
}
